import qs from 'qs';

import fetch from '@giro/shared-utils/fetch.util';

export default async function getApiTerminalsRegistrationsService(
  filters: any = {}
) {
  const filtersStringfy = qs.stringify(filters, { skipNulls: true });
  const url = ['terminals/registrations', filtersStringfy].join('?');

  return fetch(url, {
    method: 'GET',
    ms: 'PDV',
    auth: true,
  });
}
